// How to create more files like this:
// ===================================
//
// where does it live
// how to populate from server
// adding a new package
//
// - remove comments because they are not needed from the old version
// - comment rest of the code which is useful (it will be toggled later)
// - get minimal version working ("hello world")
//
// it is simliar to o

import React from "react";
import {connect} from "react-redux";
import {compose, lifecycle} from "recompose";
import Button from "react-md/lib/Buttons/Button";
import {TouchTable} from "../../../AtollonTheme/ReactElements";

import {
    getPerson,
    getOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser
} from "../../../actions/resourceActions";
import {
    addOrganizationPackageMapping,
    getOrganizationPackageMapping,
    // getOrganizationPackageMapping_forOrg,
    getOrganizationPackageMapping_forMyOrg
} from "../../../actions/OrganizationPackageMappingActions";
import {} from "../../../actions/requestActions";
import {DebugElement} from "../../debug";
import {map, isEmpty, find, forEach, sortBy, filter} from "lodash";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import { setDialog } from "../../../actions/dialogActions";
import {
    isAdmin} from "../../../utils/index"


import {OrganizationPackageMappingHeaderAsRedux} from "./OrganizationPackageMappingHeader";
import {
    GENERIC_ORGANIZATION_IDENTIFIER__FORM_VALUE,
    OrganizationPackageMapping_Add_and_Edit_AsRedux
} from "./OrganizationPackageMapping_Add_and_Edit";


// borrowed from current ui
import Header from "../../../components/ContainerHeader";

import {InfoBox, InfoBox_Field, InfoBox_TextField} from "../../../AtollonTheme/ReactElements";
import {
    ADD_ORGANIZATION_PACKAGE_FORM_NAME,
    organizationPackageMapping_getRoutePathStringForForNavigationContainer,
    organizationPackageMapping_getDetailIdFromPath,
    hasGenericOrganization
} from "./shared";
import {array_utilities} from "../../utilities/array_utilities";


//  const getHistoryUrlForOrganizationPackageMapping = ( organizationUuid, userIdAsEmail ) => {
//     return `/organizations/${organizationUuid}/user/${userIdAsEmail}/detail`;
// };
//
//  const isOrganizationPackageMappingOnThisPath = (locationReduxVariable) => {
//     let url = locationReduxVariable.pathname;
//     let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
//     if (match) {
//         return true;
//     }
// };
//
//  const getInstanceUuidFromLocation = (locationReduxVariable) => {
//     let url = locationReduxVariable.pathname;
//     let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
//     if (match) {
//         return match[1];
//     }
// };
//
//  const getUserDetailIdFromLocation = (locationReduxVariable) => {
//     let url = locationReduxVariable.pathname;
//     let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
//     if (match) {
//         return match[2];
//     }
// };
//
// const getUuidFromLocation = (locationReduxVariable) => {
//     let url = locationReduxVariable.pathname;
//     let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
//     if (match) {
//         return match[1];
//     }
// };


const OrganizationPackageMappingAsReact = (propsAsDict) => {

    let {
        role,
        history,
        // person,
        // userOrganizations,
        organizationPackageMapping,
        organizationPackageMapping_forOrg,
        location,
        // title,
        // organizationUsers,
        // organizationUsersAdmin,
        // organizationUsersOwner,
        // organizationUsersUser,
        // setDialog
        // isAdmin
        activeForm
    } = propsAsDict;

    const searchBar = propsAsDict.state.searchBar;


    // if(!isAdmin())
    if( 0 ) // //////////////////// TEST ////////////////
    {
        return (
            <div>
                <h1>Balíčky</h1>
                <div>Pouze administrátor může editovat balíčky</div>
            </div>
        );
    }
    else
    {

    }

    let admin = isAdmin(role);
    let headerAsList = ["id", "Organizace", "Kategorie serveru", "dedicated?", "Balíček"];
    if( admin )
    {
        headerAsList.push("Akce");
    }

    let organizationPackageMapping_id = organizationPackageMapping_getDetailIdFromPath( location );

    // console.log('RRR','organizationPackageMapping', {location});
    // console.log('RRR','organizationPackageMapping', {organizationPackageMapping, propsAsDict});

    let isAdding = activeForm === ADD_ORGANIZATION_PACKAGE_FORM_NAME;
    let isEditing = organizationPackageMapping_id;

    // console.log('RRR','organizationPackageMapping', {isAdding, isEditing});
    // console.log('RRR','organizationPackageMapping', {organizationPackageMapping_id});
    let top;
    if( isEditing )
    {
        let initialValuesOfEditedId = {};
        forEach( organizationPackageMapping, (item) => {
            if( item.id === organizationPackageMapping_id )
            {
                initialValuesOfEditedId = {};
                forEach( item, (value,key) => {
                    initialValuesOfEditedId[ key ] = value;
                });
                if( hasGenericOrganization( item ))
                {
                    initialValuesOfEditedId.organizationIdentifier = GENERIC_ORGANIZATION_IDENTIFIER__FORM_VALUE;
                }
            }
        });
        top = (
            <div>
                <OrganizationPackageMappingHeaderAsRedux
                    organizationPackageMapping_id={organizationPackageMapping_id}
                />
                <OrganizationPackageMapping_Add_and_Edit_AsRedux
                    organizationPackageMapping_id={organizationPackageMapping_id}
                    history={history}
                    initialValues={initialValuesOfEditedId}
                />
            </div>
        );
    }
    else if( isAdding )
    {
        top = (
            <div>
                <OrganizationPackageMappingHeaderAsRedux
                    organizationPackageMapping_id={organizationPackageMapping_id}
                />
                <OrganizationPackageMapping_Add_and_Edit_AsRedux
                    history={history}
                    initialValues={{}}
                />
            </div>
        );
    }
    else
    {
        top = ( <OrganizationPackageMappingHeaderAsRedux /> );
    }

    // let organizationPackageMapping_sorted = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( userOrganizationsAll, ['name'] );

    return (
        <div>

            {top}

            {isEditing || isAdding?
                (<div/>)
            :
                <TouchTable
                    headerAsList={headerAsList}
                    elementsAsList={
                        map(
                            filter(
                                sortBy(organizationPackageMapping, [
                                    item => {
                                        // generic organizations first
                                        return hasGenericOrganization( item )? 0: 1;
                                    },
                                    'organizationIdentifier',
                                    item => {
                                        return isEmpty( item.serverCategory )? '' : item.serverCategory.name;
                                    },
                                    'packageId'

                                ]),
                                item => {

                                    if( searchBar && searchBar.searchText )
                                    {
                                        let matches = ( string ) => {
                                            if( string )
                                            {
                                                return string.toLocaleLowerCase().match(searchBar.searchText.toLocaleLowerCase());
                                            }
                                            else
                                            {
                                                return false;
                                            }
                                        };
                                        let match = matches( item.productName ) || matches( item.productDescription ) || matches( item.packageId );
                                        return match;
                                    }
                                    else
                                    {
                                        return true;
                                    }

                            }),
                            (item, i) => {


                            let id_actionName = item.id;
                            let organization_actionName = hasGenericOrganization( item )? '(generic)' : item.organizationIdentifier;
                            let package_actionName = (
                                <div>
                                    {item.productName}<br />
                                    <i>{item.productDescription}</i><br />
                                    ({item.packageId})
                                </div>
                            );
                            let serverCategory_actionName = isEmpty( item.serverCategory )? '' : item.serverCategory.name;
                            let actions = [
                                id_actionName,
                                organization_actionName,
                                serverCategory_actionName,
                                item.dedicated? "1": "0",
                                package_actionName
                            ];

                                if( admin )
                                {
                                    actions.push((
                                            <div className="table-col actions">

                                                <Button
                                                    raised
                                                    className="btn btn-primary touchButton-6"
                                                    onClick={(event) => {


                                                            // do not
                                                            event.preventDefault();

                                                            history.push(organizationPackageMapping_getRoutePathStringForForNavigationContainer( item.id ));

                                                        //
                                                        // // FIXME: pull out
                                                        // let isEditingFromHostServerMenu = host && server;
                                                        // if( isEditingFromHostServerMenu )
                                                        // {
                                                        //     setActiveHost(host);
                                                        //     setActiveServer(server);
                                                        //     setActiveOrganization(organization);
                                                        //     setActivePackage(item);
                                                        //     history.push("/package-new");
                                                        // }
                                                        // else
                                                        // {
                                                        //     setActiveOrganization(organization);
                                                        //     setActivePackage(item);
                                                        //     history.push("/package-new");
                                                        // }
                                                    }}>Editovat</Button>
                                            </div>
                                    ));
                            }
                            return actions;
                        }
                    )}
                />
            }
        </div>
    );

    // let instanceUuid = getInstanceUuidFromLocation(location);
    // let userDetailId = getUserDetailIdFromLocation(location);
    // let userDetail = null;
    // let thisUserTouchEmail = userDetailId;
    //
    //
    // const organization = find(userOrganizations, o => o.id === instanceUuid);
    //
    // {
    //     const usersBoundToInstance = [];
    //
    //     forEach(organizationUsersAdmin, u => {
    //         usersBoundToInstance.push({ ...u, role: "admin" });
    //     });
    //     forEach(organizationUsersOwner, u => {
    //         usersBoundToInstance.push({ ...u, role: "owner" });
    //     });
    //     forEach(organizationUsersUser, u => {
    //         usersBoundToInstance.push({ ...u, role: "user" });
    //     });
    //
    //     var thisUsersBindingToInstance = find(usersBoundToInstance, u => u.name === thisUserTouchEmail);
    // }
    //
    // if (organization && organizationPackageMapping && organizationPackageMapping[userDetailId]) {
    //
    //     let userXmlAsString = organizationPackageMapping[userDetailId];
    //     let userXml = xml_utilities.xml_from_string_dontThrowExceptions( userXmlAsString );
    //
    //
    //     return (
    //         <div>
    //             <Header title={title} />
    //             <InfoBox>
    //                 <DebugElement text={"Atollon/InstaceUserDetail.js"}/>

    //                 <InfoBox_TextField
    //                     name={Translate("Profil uživatele","Profil uživatele")}
    //                     value={userDetail_getUserProfile()}
    //                 />
    //                 <InfoBox_TextField
    //                     name={Translate("Je admin?","Je admin?")}
    //                     value={yesNo(userDetail_getIsAdminAsBoolean())}
    //                 />
    //                 <InfoBox_TextField
    //                     name={Translate("Typ uživatele","Typ uživatele")}
    //                     value={userDetail_getIsPowerUser()? Translate("profil uživatele - Externí uživatel", "Externí uživatel") : Translate("profil uživatele - Power user", "Power user")}
    //                 />
    //
    //                 <FontIcon
    //                     className="icon"
    //                     onClick={() => {
    //                         setDialog("DeleteOrganizationUserBinding", {
    //                             organizationId: organization.id,
    //                             userId: thisUsersBindingToInstance.id,
    //                             name: thisUsersBindingToInstance.name
    //                         })}}
    //                 >
    //                     delete
    //                 </FontIcon>
    //
    //
    //             </InfoBox>
    //         </div>
    //     );
    // }
    // else {
    //     return (
    //         <DebugElement text={"OrganizationPackageMapping -- PASS"}/>
    //     );
    // }
};

// const getOrganizationPackageMappingData = () =>
// {
//
// };

/**
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 */

export const OrganizationPackageMappingAsRedux = compose(
    connect(
        (state) => {
            let {
                app: {
                    role,
                    form: {
                        activeForm
                    }
                },
                resource: {
                    //              person,
                    organizationPackageMapping,
                    organizationPackageMapping_forOrg
                    //              organizationUsers,
                    //              organizationUsersAdmin,
                    //              organizationUsersOwner,
                    //              organizationUsersUser
                }
            } = state;

            return (
            {
                    role,
                    // person
                    organizationPackageMapping,
                    organizationPackageMapping_forOrg,
                    // organizationUsers,
                    // organizationUsersAdmin,
                    // organizationUsersOwner,
                    // organizationUsersUser
                    state,
                    activeForm
            });
        },
        {
            // getPerson,
            // getOrganizationUserDetail,
            // getOrganizationUsers,
            // getOrganizationUsersAdmin,
            // getOrganizationUsersOwner,
            // getOrganizationUsersUser,
            // setDialog
            isAdmin,
            getOrganizationPackageMapping,
            getOrganizationPackageMapping_forMyOrg
        }
    ),
    lifecycle(
        {
            async componentWillMount() {
                // const {getOrganizationPackageMapping, match, getRequest, getOrganizationUserDetail, location} = this.props;
                const {getOrganizationPackageMapping, getOrganizationPackageMapping_forMyOrg} = this.props;
                await getOrganizationPackageMapping();
                await getOrganizationPackageMapping_forMyOrg();
            }
        }
    )
)(OrganizationPackageMappingAsReact);




// WEBPACK FOOTER //
// ./src/Atollon/pages/OrganizationPackageMapping/OrganizationPackageMapping.js